import { ReactNode } from "react";

interface InsuranceInfo {
  title: ReactNode;
  description: ReactNode;
  benefits: ReactNode[];
  examples: ReactNode[];
}

export const hvacInsurance: InsuranceInfo = {
  title: <>HVAC Insurance</>,
  description: (
    <>
      HVAC insurance protects heating, ventilation, and air conditioning
      contractors and businesses from financial risks such as property damage,
      equipment breakdowns, injuries, or lawsuits that may arise while
      installing, repairing, or maintaining HVAC systems.
    </>
  ),
  benefits: [
    <>Covers accidental damage to client property during HVAC installations or repairs.</>,
    <>Provides liability coverage for injuries to clients, tenants, or third parties.</>,
    <>Includes workers’ compensation for employees injured while on the job.</>,
    <>Protects valuable HVAC tools, testing equipment, and service vehicles.</>,
    <>May include errors & omissions coverage for faulty installations or system design.</>,
    <>Can cover refrigerant leaks or damage related to HVAC system malfunctions.</>,
  ],
  examples: [
    <>
      An HVAC contractor accidentally damages ductwork in a customer’s home
      during installation. Insurance helps cover repair costs.
    </>,
    <>
      A tenant trips over HVAC equipment left in a hallway and is injured.
      Liability coverage helps pay for their medical expenses.
    </>,
    <>
      An employee suffers a back injury while carrying a heavy furnace. Workers’
      compensation helps with treatment and lost wages.
    </>,
    <>
      A refrigerant leak from a newly installed unit causes property damage. Errors & omissions
      coverage may help cover related claims.
    </>,
    <>
      A service van loaded with HVAC tools and parts is stolen. Business auto
      and equipment coverage help replace the losses.
    </>,
  ],
};
